// import defaultLightImg from "Assets/images/default-light.svg";
// import defaultDepthImg from "Assets/images/default-depth.svg";
import defaultLightImg from 'Assets/images/default-light-big.svg';
import defaultDepthImg from 'Assets/images/default-depth-big.svg';
import { langCheck } from 'Pub/js/utils';
const defaultLight = 'defaultLight', defaultDepth = 'defaultDepth';
const colorMap = {
    "": "default",
    "#F1F1F1": "default",
    defaultDepth: "default1",
    defaultLight: "default",
    "#BF381A": "red",
    "#1561CD": "blue",
    "#138346": "green",
    "#A47238": "yellow",
    "#2E2C2C": "black"
};
const showColorMap = {
    "": "#F1F1F1",
    "#F1F1F1": "#F1F1F1",
    defaultDepth: defaultDepthImg,
    defaultLight: defaultLightImg,
    "#BF381A": "#E14624",
    "#1561CD": "#2665D6",
    "#138346": "#08964A",
    "#A47238": "#DB9340",
    "#2E2C2C": "#2E2C2C",
    // "sketch": "linear-gradient(134deg, #CC6767 0%, #3F55F2 21%, #4BCE39 43%, #FFE364 70%, #EC4444 100%)",
};
const colorNameObject = {
    "white": "#F1F1F1",
    "default": defaultLight,
    "default1": defaultDepth,
    "red": "#BF381A",
    "blue": "#1561CD",
    "green": "#138346",
    "yellow": "#A47238",
    "black": "#2E2C2C",
};
// 背景图片
const bgImgArr = [
    {
        key: 0,
        type: "backgroundImg1",
        fieldid: "backgroundImg1"
    },
    {
        key: 1,
        type: "backgroundImg2",
        fieldid: "backgroundImg2"
    },
    {
        key: 2,
        type: "backgroundImg3",
        fieldid: "backgroundImg3"
    },
    {
        key: 3,
        type: "backgroundImg4",
        fieldid: "backgroundImg4"
    },
    {
        key: 4,
        type: "backgroundImg5",
        fieldid: "backgroundImg5"
    },
    {
        key: 'custom',
        type: 'custom',
        fieldid: 'custom'
    }
]
// 背景颜色
const getBgColorArr = () => [
    {
        key: 0,
        color: "#C5C5C5",
        name: 'gray',
        defaultShow: true,
        fieldid: "defaultBgColor"
    },
    {
        key: 1,
        color: "#fff2fa",
        name: 'yellow',
        defaultShow: false,
        fieldid: "yellowBgColor"
    },
    {
        key: 2,
        color: "#effffa",
        name: 'blue',
        defaultShow: false,
        fieldid: "blueBgColor"
    },
    {
        key: 3,
        color: "#e5edff",
        name: 'green',
        defaultShow: false,
        fieldid: "greenBgColor"
    },
    {
        key: 4,
        color: "linear-gradient(134deg, #CC6767 0%, #3F55F2 21%, #4BCE39 43%, #FFE364 70%, #EC4444 100%)",
        name: 'sketch',
        defaultShow: false,
        fieldid: "sketchBgColor"
    },
]
const bgColorArr = getBgColorArr();
// 背景颜色字典
const bgColorMap = {
    "gray": "#ECF0F9",
    "yellow": "#fff2fa",
    "blue": "#effffa",
    "green": "#e5edff",
    "sketch": "",
};

// 默认背景
const defaultBackgroundObject = {
    bdtype: "color",
    bgColor: "gray",
    bgImg: "backgroundImg1",
    blurNumber: 0,
}
// 主题皮肤 数据源
const getColorArr = () => {
    return [
        // {
        //     key: 0,
        //     color: "#F1F1F1",
        //     name: langCheck("0000PUB-000282") /* 国际化处理： 默认*/,
        //     defaultShow: false,
        //     fieldid: "default"
        // },
        {
            key: 0,
            color: defaultLight,
            name: langCheck("0000PUB-000484") /* 国际化处理： 默认浅*/,
            defaultShow: true,
            fieldid: defaultLight
        },
        {
            key: 1,
            color: defaultDepth,
            name: langCheck("0000PUB-000485") /* 国际化处理： 默认深*/,
            defaultShow: false,
            fieldid: defaultDepth
        },
        {
            key: 2,
            color: "#BF381A",
            name: langCheck("0000PUB-000283") /* 国际化处理： 典雅红*/,
            defaultShow: false,
            fieldid: "red"
        },
        {
            key: 3,
            color: "#1561CD",
            name: langCheck("0000PUB-000284") /* 国际化处理： NC蓝*/,
            defaultShow: false,
            fieldid: "blue"
        },
        {
            key: 4,
            color: "#138346",
            name: langCheck("0000PUB-000285") /* 国际化处理： 舒眼绿*/,
            defaultShow: false,
            fieldid: "green"
        },
        {
            key: 5,
            color: "#A47238",
            name: langCheck("0000PUB-000286") /* 国际化处理： 跃动黄*/,
            defaultShow: false,
            fieldid: "yellow"
        },
        {
            key: 6,
            color: "#2E2C2C",
            name: langCheck("0000PUB-000287") /* 国际化处理： 暗夜黑*/,
            defaultShow: false,
            fieldid: "black"
        },
        // {
        //     key: 7,
        //     color: "sketch",
        //     name: 'sketch',
        //     defaultShow: false,
        //     fieldid: "sketchThemeColor"
        // },
    ]
}

const defaultFormTitleColor = '#616161'; // 表单标题默认色

export default {
    colorMap,
    showColorMap,
    bgImgArr,
    bgColorArr,
    bgColorMap,
    defaultBackgroundObject,
    colorNameObject,
    defaultLight,
    defaultDepth,
    getColorArr,
    defaultFormTitleColor,
    getBgColorArr,
};

